"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apiOrderToAppOrder_1 = __importDefault(require("../../libs/apiOrderToAppOrder"));
const appBatchToApiBatch_1 = __importDefault(require("../../libs/appBatchToApiBatch"));
const appPaymentToApiPayment_1 = __importDefault(require("../../libs/appPaymentToApiPayment"));
class OrderApi {
    constructor(api) {
        this.api = api;
    }
    // * Order level api
    getOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order?id=${orderId}`;
            const response = yield this.api.axiosGo.get(endpoint);
            return apiOrderToAppOrder_1.default(response.data.data[0]);
        });
    }
    getOrderByInfo(info) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/order/info', { params: info });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    getOrders(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order';
            const response = yield this.api.axiosGo.get(endpoint, { params: query });
            return response.data.data.filter((order) => order.apiVersion === this.api.apiVersion).map(apiOrderToAppOrder_1.default);
        });
    }
    createOrder(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    updateOrder(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}`;
            const response = yield this.api.axiosGo.put(endpoint, data);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    surchargeOrder(orderId, surcharge) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/surcharge`;
            const response = yield this.api.axiosGo.post(endpoint, surcharge);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 覆蓋掉 order.modifiers
    updateModifiers(orderId, modifiers) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/modifier`;
            const response = yield this.api.axiosGo.post(endpoint, { modifiers });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 更改人數
    updateCustomerCount(orderId, adults, children) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/customercount`;
            const response = yield this.api.axiosGo.post(endpoint, {
                count: adults + children,
                adults,
                children,
            });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 移桌，給 from, to 桌號
    updateTable(orderId, from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/table`;
            const response = yield this.api.axiosGo.post(endpoint, { from, to });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 更改 tags
    updateTags(orderId, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/tag`;
            const response = yield this.api.axiosGo.post(endpoint, { tags });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 併單，從 fromOrderId 併到 orderId
    mergeOrder(orderId, fromOrderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/merge`;
            const response = yield this.api.axiosGo.post(endpoint, { orderId: fromOrderId });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    payOrder(orderId, payment) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiPayment = appPaymentToApiPayment_1.default(payment);
            const endpoint = `/m/order/${orderId}/pay`;
            const response = yield this.api.axiosGo.put(endpoint, apiPayment);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    updateOrderPayment(orderId, paymentId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/payment/${paymentId}`;
            const response = yield this.api.axiosGo.put(endpoint, data);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    deleteOrderPayment(orderId, paymentId, reason) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/payment/${paymentId}`;
            const response = yield this.api.axiosGo.delete(endpoint, { params: { reason } });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    updateOrderRemark(orderId, remark) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/remark`;
            const response = yield this.api.axiosGo.put(endpoint, { remark });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 取消、退桌、作廢、外送拒接單
    cancelOrder(id, reason, identifier) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/cancel`;
            const response = yield this.api.axiosGo.put(endpoint, {
                reason,
                identifier,
            });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 外送接單
    confirmOrder(id, deviceId, reconfirm = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/confirm`;
            const response = yield this.api.axiosGo.post(endpoint, {
                deviceId,
                batchIndices: [0],
                reconfirm,
            });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 確認堂食單
    confirmBatch(id, deviceId, reconfirm = false, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/confirm`;
            const response = yield this.api.axiosGo.post(endpoint, {
                deviceId,
                batchIndices: [index],
                reconfirm,
            });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 取消單
    cancelBatch(id, deviceId, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/cancelbatch`;
            const response = yield this.api.axiosGo.post(endpoint, {
                deviceId,
                batchIndices: [index],
            });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 出餐
    readyOrder(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/ready`;
            const response = yield this.api.axiosGo.put(endpoint);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 取餐
    completeOrder(id, code) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/complete`;
            const response = yield this.api.axiosGo.put(endpoint, {
                code,
            });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 手動送達 (店家自己送才要)
    deliverOrder(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/deliver`;
            const response = yield this.api.axiosGo.put(endpoint);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // * Batch level api
    submitBatch(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = appBatchToApiBatch_1.default(params);
            const endpoint = `/m/order/${params.orderId}/submit`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // * Item level api
    // 更改價格
    updateItemPrice(orderId, itemId, price) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/price`;
            const response = yield this.api.axiosGo.post(endpoint, { price });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 更改折扣
    updateItemModifiers(orderId, itemId, modifiers) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/modifier`;
            const response = yield this.api.axiosGo.post(endpoint, { modifiers });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 更改 tags
    updateItemTags(orderId, itemId, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/tag`;
            const response = yield this.api.axiosGo.post(endpoint, { tags });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // 取消 item
    cancelOrderItem(orderId, itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/cancel`;
            const response = yield this.api.axiosGo.put(endpoint);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    revealOrderItem(orderId, itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/reveal`;
            const response = yield this.api.axiosGo.put(endpoint);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    // * Reports
    getOrderStatCategory(from, // timestamp (seconds)
    to, // timestamp (seconds)
    cancelled = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const api = cancelled ? this.api.axiosGo : this.api.axiosNode;
            const response = yield api.get('/m/order/stat/category', {
                params: {
                    from,
                    to,
                    cancelled,
                },
            });
            return response.data;
        });
    }
    getOrderStatSummary(from, // timestamp (seconds)
    to, // timestamp (seconds)
    cancelled, deliveryType, takeaway) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                from,
                to,
                cancelled,
            };
            if (deliveryType != null) {
                params.deliveryType = deliveryType;
            }
            if (takeaway != null) {
                params.takeaway = takeaway;
            }
            const response = yield this.api.axiosGo.get('/m/order/stat/summary', { params });
            return response.data;
        });
    }
    getOrderStatUnpaid(from, // timestamp (seconds)
    to) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/order/stat/unpaid', {
                params: {
                    from,
                    to,
                },
            });
            return response.data;
        });
    }
    // ? 不確定回應格式，後端專案未定義 response 且經測試 api 回應 []
    getOrderStatCancel(from, // timestamp (seconds)
    to, // timestamp (seconds)
    takeaway) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                from,
                to,
            };
            if (takeaway != null) {
                params.takeaway = takeaway;
            }
            const response = yield this.api.axiosGo.get('/m/order/stat/cancel', { params });
            return response.data;
        });
    }
    surchargeOrderItems(uid, itemIDs, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post(`/m/order/${uid}/surchargemenu`, {
                itemIDs: itemIDs,
                value: value,
            });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
}
exports.default = OrderApi;
//# sourceMappingURL=Order.js.map